import {
    apiRequest,
    lemburList
} from "../../../../../services/adapters/kepegawaian/lemburService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", lemburList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository